import { render, staticRenderFns } from "./OperationButtons.vue?vue&type=template&id=7527a722&scoped=true&"
import script from "./OperationButtons.vue?vue&type=script&lang=js&"
export * from "./OperationButtons.vue?vue&type=script&lang=js&"
import style0 from "./OperationButtons.vue?vue&type=style&index=0&id=7527a722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527a722",
  null
  
)

export default component.exports